import storageManager from "modules/storage-manager";

const getPlatformCode = () => {
    const userData = storageManager.user.get();
    const platform = userData?.platform;

    return platform;
}

export default getPlatformCode;